import { IApplicationProperty } from '@apply/api/src/api/ApplyApi';
import { useApplicationCache } from '../../../queries/useApplicationCache';

export function usePropertiesCache(): IApplicationProperty[] {
    return useApplicationCache(d => d.information?.properties?.items ?? []) ?? [];
}
